import { createValidationMessage } from '../../../../validation/create-validation-message'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import { createUIDefinition } from '../default-task-definition'
import * as taskName from './task-name'
import * as processUI from '../../process-ui'


export default createUIDefinition({
    taskName: taskName.CHECK_SCANS,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.TRAY_SIZE_WIDGET,
        },
        {
            component: processUI.IMPRINT_SCAN_STATUS_WIDGET,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context) => {
        const messageList = []


        const upperJawScanOk = context.upperJawScanOk
        const lowerJawScanOK = context.lowerJawScanOK

        // // make sure at least one is true
        if (eventName === 'both_imprints_scan_ok' && (!upperJawScanOk || !lowerJawScanOK)) {
            messageList.push(createValidationMessage('For this action both scans have to be ok.', 'validateCheckScans.both_imprints_scan_ok'))
        }

        // both have to be false
        if (eventName === 'at_least_one_imprint_scan_not_ok' && upperJawScanOk && lowerJawScanOK) {
            messageList.push(createValidationMessage('For this action at least one scan has to be not ok.', 'validateCheckScans.at_least_one_imprint_scan_not_ok'))
        }

        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/check-scans.js